export default data => {
  const str = `
    <div class="activity" js-card-activity="{activityID: ${data.id}}">
      <span class="gen-text--S">${data.text}</span>
        <div class="icon-close" js-card-delete>
          <svg width="13px" height="13px" class="icon icon--red" aria-hidden="true">
              <use href="#icon-close" xlink:href="#icon-close" />
          </svg>
        </div>
        <input type="hidden" name="category[${data.id}]" value="${data.id}"/>
      </div>`

  return str
}
